export const IconGolPenal = () => {
  return (
    <svg
      className="w-full"
      enableBackground="new 0 0 25 25"
      viewBox="0 0 25 25"
      x="0px"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      y="0px"
    >
      <g>
        <path
          d="M12.6,1.1L12.6,1.1c6.4,0,11.5,5.1,11.5,11.5l0,0c0,6.4-5.1,11.5-11.5,11.5
		l0,0C6.3,24.1,1.1,19,1.1,12.6l0,0C1.1,6.3,6.3,1.1,12.6,1.1z"
          fill="#E3EAFF"
        />
        <path
          d="M12.6,1.8L12.6,1.8
		c6,0,10.8,4.8,10.8,10.8l0,0c0,6-4.8,10.8-10.8,10.8l0,0c-6,0-10.8-4.8-10.8-10.8l0,0C1.8,6.7,6.7,1.8,12.6,1.8z"
          fill="none"
          stroke="#E3EAFF"
          strokeWidth="1.4133"
        />
        <path
          d="M14.8,19.1v-6.8h2.9c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.4,0.1,0.7,0.2,1,0.4c0.3,0.2,0.5,0.5,0.6,0.8
		c0.1,0.3,0.2,0.7,0.2,1c0,0.4-0.1,0.7-0.2,1c-0.1,0.3-0.3,0.6-0.6,0.8c-0.3,0.2-0.6,0.3-1,0.4c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.2,0-0.3,0h-1.6v2.3H14.8z M16.1,15.6h1.5c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2
		c0.1-0.1,0.2-0.2,0.2-0.4c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3-0.1-0.4c0-0.1-0.1-0.3-0.2-0.4c-0.1-0.1-0.2-0.2-0.4-0.2
		c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0h-1.5V15.6z"
          fill="#3366FF"
        />
      </g>
      <g>
        <g clipPath="url(#SVGID_00000034074999242477482420000017955005489469312674_)">
          <path
            d="M14.1,5.1h-10v10h10V5.1z"
            fill="#FFFFFF"
            fillOpacity="1.000000e-02"
          />
          <path
            d="M9.1,14.3
			c2.3,0,4.2-1.9,4.2-4.2s-1.9-4.2-4.2-4.2C6.8,5.9,5,7.8,5,10.1S6.8,14.3,9.1,14.3z"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
          <path
            d="M10.4,6.5L9.1,7.4
			v0.9l1.6,1.3l0.9-0.4l0.5-1.5"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
          <path
            d="M7.9,6.5l1.3,0.9
			v0.9L7.5,9.6L6.6,9.2L6.1,7.7"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
          <path
            d="M5.4,9.7l1.3-0.5
			l0.9,0.4l0.5,2l-0.5,0.7H5.9"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
          <path
            d="M7.5,13.6v-1.3
			l0.5-0.7h2.2l0.5,0.7v1.3"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
          <path
            d="M12.4,12.3h-1.6
			l-0.5-0.7l0.5-2l0.9-0.4l1.4,0.7"
            fill="none"
            stroke="#3366FF"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.7353"
          />
        </g>
      </g>
    </svg>
  );
};
